export default __webpack_public_path__ + "static/media/wordmark-tag.f7613811.svg";